import { render, staticRenderFns } from "./DeductionAuth.vue?vue&type=template&id=04b84228&scoped=true"
import script from "./DeductionAuth.vue?vue&type=script&lang=js"
export * from "./DeductionAuth.vue?vue&type=script&lang=js"
import style0 from "./DeductionAuth.vue?vue&type=style&index=0&id=04b84228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b84228",
  null
  
)

export default component.exports